export { default } from './QuickAccessBar';
